export default __webpack_public_path__ + "static/media/slolana.50843ac6.ico";